import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=6d80c31e&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=6d80c31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80c31e",
  null
  
)

export default component.exports